<script lang="ts">
import { defineComponent } from 'vue';
import Headline from '@/components/headline.vue';
import Tabs from '@/components/tabs.vue';
import PoolTypes from '@/components/pools/pool-types.vue';
import Pools from '@/components/pools/pools.vue';
import Pool from '@/components/pools/pool.vue';
import { mapWritableState } from 'pinia';
import { usePoolsStore } from '@/stores/pools';
import PoolBets from '@/components/pools/pool-bets.vue';

export default defineComponent({
  name: 'toto',
  components: { PoolBets, Pools, PoolTypes, Headline, Tabs, Pool },
  computed: {
    ...mapWritableState(usePoolsStore, ['tab', 'currentPoolId', 'pools']),
    tabs() {
      if (!this.currentPoolId) {
        return [
          { id: 'types', name: 'Типы', params: [] },
          { id: 'pools', name: 'Пулы', params: [] },
        ];
      }

      const pool = this.pools?.find(({ id }) => id === this.currentPoolId);

      return [
        { id: 'types', name: 'Типы', params: [] },
        { id: 'pools', name: 'Пулы', params: [] },
        { id: 'stakes', name: `Ставки (${pool.name})`, params: [] },
      ];
    },
  },
});
</script>

<template>
  <teleport to="#title">
    <headline class="mx-4 my-2">
      Тотализаторы
      <template #counter>{{ tabs[tab].name }}</template>
    </headline>
  </teleport>
  <tabs :tabs="tabs" v-model="tab">
    <template #types>
      <pool-types />
    </template>
    <template #pools>
      <pools />
      <pool />
    </template>
    <template #stakes>
      <pool-bets />
    </template>
  </tabs>
</template>

<style scoped lang="scss"></style>
